import React, { useState } from "react";
import PerformaCheck from "./PerformaCheck";

const TalentPool = ({ applicatns }) => {
  const [viewData, setViewData] = useState([]);

  const handelView = (e, value) => {
    e.preventDefault();
    setViewData(value);
  };

  return (
    <>
      <div className="col-lg-12">
        <PerformaCheck
          viewData={viewData}
          offcanvasid={"offcanvasRightCreate1"}
          labelledby={"offcanvasRightLabel1"}
        />
        <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none" }}>
          <div className="card-body">
            <div className="col-lg-12">
              <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none" }}>
                <div className="card-body p-0">
                  <table className="table mb-0 table-striped custom-table">
                    <thead>
                      <tr className="tableHeaderbg text-center">
                        <th className="text-center">Applicant's Name</th>
                        <th className="text-center">Apply for</th>
                        <th className="text-center">Applied Location</th>
                        <th className="text-center">Email</th>
                        <th className="text-center">CV</th>
                        <th className="text-center">Check Performa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {applicatns && applicatns.length > 0 ? (
                        applicatns.map((es) => (
                          <>
                            {es.applicants
                              .filter((es) => es.status === "talentpool")
                              .map((ess) => (
                                <tr className="text-center">
                                  <th scope="row">
                                    {ess.first_name}
                                    {ess.first_name}
                                  </th>
                                  <td className="tableset">{es.title}</td>
                                  <td className="tableset">{ess.location}</td>
                                  <td className="tableset">{ess.email}</td>

                                  <td className="tableset">
                                    <a
                                      target="_blank"
                                      href={`${process.env.REACT_APP_CV_PATH}/${ess.cv}`}
                                    >
                                      <i className="uil-eye iconscolor" />
                                    </a>
                                  </td>
                                  <td className="tableset">
                                    <button
                                      onClick={(e) => handelView(e, ess.performa)}
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#offcanvasRightCreate1"
                                      aria-controls="offcanvasRight1"
                                      className="btn btnclr"
                                    >
                                      Performa Check
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </>
                        ))) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No talented applicant records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TalentPool;
